// extracted by mini-css-extract-plugin
export var label = "_gq-2";
export var slideContainer = "_gq-0";
export var slider = "_gq-1";